__turbopack_context__.v({
  "icon": "tooltip-module-scss-module__0KJTaW__icon",
  "tooltip": "tooltip-module-scss-module__0KJTaW__tooltip",
});
